import AppConfig from "../../../../../src/AppConfig";
import ApiReqJson from "../ApiReqJson";

const urlRegistro = AppConfig.urlApiBase + '/cliente_registro';


const apiClienteRegistro= {
  DataIni: async () => {
    const url = `${urlRegistro}/data_ini`;
    return await ApiReqJson.requestGET(url);
  },
  Crear: async (data) => {
    const url = `${urlRegistro}/solcw_create`;
    return await ApiReqJson.requestPOST(url, {data});
  },
  SetListaUrlPutS3: async (idsol, lista) => {
    const url = `${urlRegistro}/update_listaUrlS3`;
    const data = {
      idsol, lista
    };
    return await ApiReqJson.requestPOST(url, data);
  },
  Prueba: async () => {
    const url = `${urlRegistro}/prueba`;
    return await ApiReqJson.requestGET(url);
  }
};

export default apiClienteRegistro;

